var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Dialog', {
    attrs: {
      "title": "Edit HubSpot Rule",
      "show": _vm.isOpen,
      "onClose": _vm.onClose
    }
  }, [_c('el-form', {
    attrs: {
      "model": _vm.item,
      "label-width": "160px",
      "label-position": "left",
      "size": "small"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Anima event",
      "required": ""
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "Select...",
      "filterable": "",
      "loading": _vm.loading.events,
      "loading-text": "Loading..."
    },
    model: {
      value: _vm.item.event_action,
      callback: function ($$v) {
        _vm.$set(_vm.item, "event_action", $$v);
      },
      expression: "item.event_action"
    }
  }, _vm._l(_vm.events, function (event) {
    return _c('el-option', {
      key: event,
      attrs: {
        "label": event,
        "value": event
      }
    });
  }), 1)], 1), _c('el-form-item', {
    attrs: {
      "label": "HubSpot event name",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: _vm.item.hubspot_event_name,
      callback: function ($$v) {
        _vm.$set(_vm.item, "hubspot_event_name", $$v);
      },
      expression: "item.hubspot_event_name"
    }
  })], 1), _c('el-form-item', {
    attrs: {
      "label": "HubSpot event ID",
      "required": ""
    }
  }, [_c('el-input', {
    model: {
      value: _vm.item.hubspot_event_id,
      callback: function ($$v) {
        _vm.$set(_vm.item, "hubspot_event_id", $$v);
      },
      expression: "item.hubspot_event_id"
    }
  })], 1)], 1), _c('div', {
    staticClass: "properties-title"
  }, [_c('h3', [_vm._v("Properties")]), _c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini",
      "icon": "el-icon-plus",
      "round": ""
    },
    on: {
      "click": _vm.addProperty
    }
  }, [_vm._v(" Add")])], 1), _c('el-form', {
    attrs: {
      "model": _vm.item.hubspot_properties_map,
      "label-width": "160px",
      "label-position": "left",
      "size": "small"
    }
  }, [_vm.item.hubspot_properties_map && _vm.item.hubspot_properties_map.length > 0 ? _c('el-form-item', [_c('el-row', {
    attrs: {
      "gutter": _vm.gutter
    }
  }, [_c('el-col', {
    staticClass: "column-header",
    attrs: {
      "span": _vm.inputSpan
    }
  }, [_vm._v("Anima")]), _c('el-col', {
    staticClass: "column-header",
    attrs: {
      "span": _vm.inputSpan
    }
  }, [_vm._v("HubSpot")])], 1)], 1) : _vm._e(), _vm._l(_vm.item.hubspot_properties_map, function (prop, index) {
    return _c('el-form-item', {
      key: index,
      attrs: {
        "label": `Property ${index + 1}`
      }
    }, [_c('el-row', {
      attrs: {
        "gutter": _vm.gutter
      }
    }, [_c('el-col', {
      attrs: {
        "span": _vm.inputSpan
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Anima property"
      },
      model: {
        value: prop.anima_parameter_name,
        callback: function ($$v) {
          _vm.$set(prop, "anima_parameter_name", $$v);
        },
        expression: "prop.anima_parameter_name"
      }
    })], 1), _c('el-col', {
      attrs: {
        "span": _vm.inputSpan
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "Hubspot property"
      },
      model: {
        value: prop.hubspot_property_name,
        callback: function ($$v) {
          _vm.$set(prop, "hubspot_property_name", $$v);
        },
        expression: "prop.hubspot_property_name"
      }
    })], 1), _c('el-col', {
      attrs: {
        "span": _vm.actionSpan
      }
    }, [_c('el-link', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function ($event) {
          return _vm.removeProperty(index);
        }
      }
    }, [_vm._v("Remove")])], 1)], 1)], 1);
  }), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.item.id ? 'Save' : 'Create'))]), _c('el-button', {
    on: {
      "click": function ($event) {
        return _vm.onClose();
      }
    }
  }, [_vm._v("Cancel")])], 1)], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }